export default {
    userNavSection: {
        myPage: 'My page',
        myProfile: 'My profile',
        myTests: 'Assessments',
        myApplications: 'Applications',
        myFavorites: 'Favorites',
        internalResources: 'Resources',
        calendar: 'Calendar',
        documents: 'My Documents',
        referrals: 'Refer a friend',
        plansAndBilling: 'Plans & Billing',
    },

    searchModule: {
        searchBar: {
            label: 'Search by title or keywords',
        },
        filters: {
            clearFilters: 'Clear filters',
        },
        filterLimit: {
            title: 'Filter limit reached',
            message: 'No more filters of this type can be selected',
        },
    },

    postingModule: {
        postingModule: {
            positions: 'Positions',
            estimatedCount: 'ca {count} of {totalCount}',
            knownCount: '{count} of {totalCount}',
            noMatchFound: "Couldn't find anything that matches your criteria",
        },
        postItem: {
            applyBefore: 'Application deadline',
            remote: 'Work remotely',
        },
        postCard: {
            deadline: 'Deadline',
        },
    },

    loginModule: {
        emailVerificationTip: 'It may take a few minutes for it to reach your inbox.',
        noEmail: 'No email? Please check your spam filter or:',
        tos: `By continuing, you agree to our <a href="https://highered.global/terms-and-conditions/" target="_blank">Terms and conditions</a> and acknowledge
                that you have read our <a href="https://highered.global/privacy-policy/" target="_blank">Privacy Policy</a> to learn how we collect, use,
                and share your data.`,

        logIn: 'Log in',

        socialAuthBtns: {
            continueWithFacebook: 'Continue with Facebook',
            continueWithGoogle: 'Continue with Google',
            continueWithLinkedIn: 'Continue with LinkedIn',
            continueWithWeChat: 'Continue with WeChat',
        },

        verifyEmail: {
            verifyYourEmail: 'Please verify your email',
            weSentAnEmailTo: 'We sent a verification to',
            continueToSignIn: 'Continue to sign-in',
            resendEmail: 'Resend verification link',
            newEmailSent: 'New email sent',
        },

        registerForm: {
            recommendation: `We recommend that you use your personal email and not your
            school email to ensure you have access to your data after you
            graduate.`,
            register: 'Register',
            passwordsNotMatch: 'The passwords do not match',
        },

        logInPaper: {
            useEmail: 'or use your email',
            noAccount: `Don't have an account?`,
            signUp: 'Sign up',
            logInToAccess: 'Log in to access this feature',

            showAllOptions: 'Show all login options',
            hideAllOptions: 'Show less',
        },

        logInForm: {
            logIn: 'Log in',
            forgotPassword: 'Forgot password?',
        },

        forgotPassword: {
            title: 'Request password reset',
            description: `No worries - everyone forgets their password from time to time.
                Enter your email below to reset your password`,
            resetPassword: 'Reset password',

            emailSentTitle: 'Your help is on its way!',
            emailHasBeenSent: `An email has been sent to
                            <br>
                            <strong>{email}</strong>
                            <br>
                            with instructions on how to reset your password. Please check your
                            inbox.`,

            noEmail: 'No email?',
            sendEmailOneMoreTime: 'Send email one more time',

            resendErrorTitle: 'Error during recovering password',
            resendErrorMessage: 'Was not able to send recover-password email. Maybe wrong email?',
        },
    },

    universityBadges: {
        addAnotherUniversity: 'Add another university',
        verificationDialog: {
            verifiedStudent: 'Verified {schoolAbbr} student',
            verificationDescription:
                'You are a verified {schoolAbbr} student with the email {email}',
            verificationDescriptionNoEmail: 'You are a verified {schoolAbbr} student',
            checkYourEmail: 'Check your {schoolAbbr} email.',
            sentEmailDescription:
                'We sent you an email regarding verification for {schoolAbbr} at {email}. Please check your email.',
            resendEmail: 'Resend email',
            cancelVerification: 'Cancel verification',
            notYetVerified: 'University affiliation not yet verified.',
            verifyYourAffiliation:
                'To access {schoolAbbr} specific features like exclusive job postings and resources, please verify your affiliation.',
            verify: 'Verify',
            goToPlatform: 'Go to platform',

            verificationPending: 'Verification pending',
            verificationPendingDescription:
                'Career services at {schoolAbbr} are verifying your request. You will be contacted by email when verification is finished.',
        },
    },

    universityAvatar: {
        dialogs: {
            verificationDialog: {
                verifiedStudent: 'Verified {uniSubDomain} student',
                verifiedStudentWithEmail:
                    'You are a verified {uniSubDomain} student with the email {email}',
                checkEmail: 'Check your {uniSubDomain} email.',
                sentEmailInfo:
                    'We sent you an email regarding verification for {uniSubDomain} at {email}. Please check your email.',
                resendEmail: 'Resend email',
                cancelVerification: 'Cancel verification',
                notYetVerified: 'University affiliation not yet verified.',
                resourceAccessInfo:
                    'To access {uniSubDomain} specific features like exclusive job postings and resources, please verify your affiliation.',

                verificationCancelled: 'Verification cancelled',
                emailSent: 'Email sent',
            },
        },
    },

    termsAndConds: {
        termsAndConditions: 'Terms & Conditions',
        privacyPolicy: 'Privacy policy',
        talentPanel: 'School/Employer?',
        enjoyingHighered: 'Enjoying Highered?',
    },

    favoriteModule: {
        favoriteCard: {
            deleted: 'Deleted',
            deletedTitle: 'This position is no longer available',
        },
    },
    pageNotFound: {
        header: '404',
        description: 'Looks like the page you were looking for is no longer here.',
        goToHome: 'Go to home page',
        contactus: 'Contact us',
    },
    chat: {
        liveNow: 'Live on chat now!',
        seeAll: 'All',
        schoolSpecificChats: 'Quick access',
        help: 'Need help?',
        chatExistsLabel: 'Chat exists',
    },
    countdown: {
        day: 'day',
        days: 'days',
        hour: 'hour',
        hours: 'hours',
        minute: 'minute',
        minutes: 'minutes',
        second: 'second',
        seconds: 'seconds',
    },
};
